import type { BuildingSidebarSections } from "../../../types/buildings-sections/sidebar";

export const sidebar: BuildingSidebarSections = {
  dashboard: "Dashboard",
  actions: "Actions",
  documents: "Documents",
  viewBuilding: "Building",
  viewProjects: "Projects",
  projectLabel: "Project",
  wholeBuilding: "Whole building",
  projectUnavailable: "Project unavailable",
  chooseProject: "Choose a project",
  noProjectsYet: "No projects yet",
  buildingData: "Building Data",
  modelsSection: "Viewers",
  model3d: "Model",
  permits: "Permits",
  team: "Team",
  budgets: "Budgets",
  payments: "Payments",
  projections: "Projections",
  lca: "CO2 Analysis",
  esg: "ESG",
  help: "Help",
  building: "Building dashboard",
  materialBank: "Material Bank",
  buildingsList: "Buildings",
};
